export default "/images/aryahome.png?e98dc236514cff0f5a4366475bae332c";